

import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, Container } from "react-bootstrap";
import DataTable from "react-data-table-component";
import ModificationProductionProduct from "./ModificationProductionProduct";
import { FaRegSquarePlus } from "react-icons/fa6";
import Select from "react-select";
import config from "../../config/config";
import axios from "axios";
import Loader from "../loader/Loader";
import { getAuthToken } from "../../utils/token";
import { toast } from "react-toastify";

const customStyles = {
  headCells: {
    style: {
      fontWeight: "bold",
      fontSize: "14px",
      backgroundColor: "#f8f9fa",
    },
  },
};

export default function ModificationProductionModal({ show, handleClose,refreshParent }) {
  const [modificationProductionProduct, setModificationProductionProduct] = useState(false);
  const [modificationtoproductionplan, setModificationtoproductionplan] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modificationId, setModificationId] = useState(null);
  const [productRows, setProductRows] = useState([
    { id: 1, product_name: "", po_number: "", months: {} },
  ]);
  const [productOptions, setProductOptions] = useState([]);
  const [poList, setPoList] = useState([]);

  // const getNextElevenMonths = () => {
  //   const months = [
  //     { label: "January", value: 1 },
  //     { label: "February", value: 2 },
  //     { label: "March", value: 3 },
  //     { label: "April", value: 4 },
  //     { label: "May", value: 5 },
  //     { label: "June", value: 6 },
  //     { label: "July", value: 7 },
  //     { label: "August", value: 8 },
  //     { label: "September", value: 9 },
  //     { label: "October", value: 10 },
  //     { label: "November", value: 11 },
  //     { label: "December", value: 12 },
  //   ];

  //   const currentMonthIndex = new Date().getMonth(); // 0-11
  //   const nextMonths = [];

  //   for (let i = 1; i <= 12; i++) {
  //     nextMonths.push(months[(currentMonthIndex + i) % 12]);
  //   }
  //   return nextMonths;
  // };
  const getNextElevenMonths = () => {
    const months = [
      { label: "January", value: 1 },
      { label: "February", value: 2 },
      { label: "March", value: 3 },
      { label: "April", value: 4 },
      { label: "May", value: 5 },
      { label: "June", value: 6 },
      { label: "July", value: 7 },
      { label: "August", value: 8 },
      { label: "September", value: 9 },
      { label: "October", value: 10 },
      { label: "November", value: 11 },
      { label: "December", value: 12 },
    ];

    const nextMonths = [];

    for (let i = 0; i < 12; i++) {
      nextMonths.push(months[i]);
    }

    return nextMonths;
  };
  const months = getNextElevenMonths();
  // Add a new blank product row
  const addNewRow = () => {
    setProductRows((prev) => [
      ...prev,
      { id: prev.length + 1, product_name: "", po_number: "", months: {} },
    ]);
  };
  // Handle input change
  const handleInputChange = (rowId, field, value, monthValue = null) => {
    setProductRows((prev) =>
      prev.map((row) =>
        row.id === rowId
          ? monthValue !== null
            ? {
              ...row,
              months: {
                ...row.months,
                [monthValue]: value,
              },
            }
            : { ...row, [field]: value }
          : row
      )
    );
  };


  // ---------------- Fetch Product List ----------------
  const fetchProductList = async () => {
    const token = getAuthToken();
    if (!token) return;
    setLoading(true);
    try {
      const response = await axios.get(`${config.API}/product/list`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const options =
        response?.data?.products?.map((p) => ({
          value: p.id,
          label: p.name,
        })) || [];
      setProductOptions(options);
    } catch (err) {
      console.error("Error fetching products:", err.message);
    } finally {
      setLoading(false);
    }
  };

  // ---------------- Fetch PO Number List ----------------
  const fetchPoNumberList = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/purchaseorder/list`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const options =
        response?.data?.data?.map((po) => ({
          value: po.id,
          label: po.po_number,
        })) || [];
      setPoList(options);
    } catch (err) {
      console.error("Error fetching PO list:", err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProductList();
    fetchPoNumberList();
  }, []);

  // ---------------- Fetch Modification Plan ----------------
  const fetchModificationPlan = async () => {
    const token = getAuthToken();
    if (!token) return;
    setLoading(true);
    try {
      const response = await axios.get(`${config.API}/manager/modificationtoproductionplan`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const plans = response?.data?.plans || [];
      setModificationtoproductionplan(plans);
    } catch (err) {
      console.error("Error fetching modification plan:", err.message);
      toast.error("Failed to fetch modification plan!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchModificationPlan();
  }, []);




  // ---------------- Submit Form ----------------
  const handleSubmit = async () => {
    const token = getAuthToken();
    if (!token) return;

    const finalPayload = [];

    productRows.forEach((row) => {
      const po = poList.find((p) => p.value === row.po_number);
      const product = productOptions.find((p) => p.value === row.product_name);
      const production = [];
      Object.entries(row.months).forEach(([monthValue, qty]) => {
        const qtyNum = Number(qty);
        if (qtyNum > 0) {
          production.push({
            month: Number(monthValue),
            qty: qtyNum,
          });
        }
      });
      if (production.length) {
        finalPayload.push({
          po_id: po?.value,
          product_id: product?.value,
          product_name: product?.label,
          production,
        });
      }
    });

    if (finalPayload.length === 0) {
      toast.warn("Please add at least one product with quantity!");
      return;
    }

    try {
      setLoading(true);
      const res = await axios.post(`${config.API}/manager/ProductionPlan`, finalPayload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res?.data) {
        toast.success(res.data.message || "Production plan saved successfully!");
        setProductRows([{ id: 1, product_name: "", po_number: "", months: {} }]);
        await refreshParent();
        handleClose();
        fetchModificationPlan();
      }
    } catch (err) {
      console.error("Error submitting production plan:", err);
      toast.error(err?.response?.data?.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  // ---------------- DataTable Columns ----------------
  const columns = [
    { name: "MONTH", selector: (row) => row.month, sortable: true },
    { name: "PRODUCT", selector: (row) => row.product?.name || "", sortable: true },
    {
      name: "PLANNED",
      selector: row =>
        Number(row?.qty_produced || 0) + Number(row?.qty_pending || 0),
      sortable: true,
    },
    {
      name: "ACTUAL",
      selector: (row) => row.qty_produced,
      sortable: true,
      cell: (row) => `${row.qty_produced}`,
    },
    {
      name: "PENDING",
      selector: (row) => row.qty_pending,
      sortable: true,
      cell: (row) => `${row.qty_pending}`,
    },
    {
      name: "ACTIONS",
      cell: (row) => (
        <Button
          onClick={() => {
            setModificationId(row?.product_id);
            setModificationProductionProduct(true);
          }}
          size="sm"
          variant="dark"
        >
          Edit Plan
        </Button>
      ),
    },
  ];

  // ---------------- UI ----------------
  return (
    <>
      <Modal show={show} onHide={handleClose} size="xl" centered className="font_family">
        <div className="p-3 p-sm-4">
          <Modal.Header closeButton className="border-0">
            <Modal.Title>
              <strong>Modification to Production Plan</strong>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="pt-0">
            <Container fluid>
              {/* Header */}
              <div className="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center mb-3 gap-2">
                <h5 className="mb-0">Monthly Production Planning Board</h5>
              <div className="ms-auto d-flex flex-wrap gap-2">
              <span className="form-select-sm w-auto">
                Overall
              </span>
            </div>
              </div>

              {/* DataTable */}
              {loading ? (
                <Loader />
              ) : (
                <DataTable
                  columns={columns}
                  customStyles={customStyles}
                  data={modificationtoproductionplan}
                  pagination
                  highlightOnHover
                  responsive
                  dense
                  noHeader
                />
              )}

              {/* Add Product Section */}
              <div className="rounded p-3 mt-4 bg-light shadow-sm">
                <div
                  className="d-flex align-items-center mb-4"
                  onClick={addNewRow}
                  style={{ cursor: "pointer" }}
                >
                  <FaRegSquarePlus className="me-2" />
                  <span>Add New Product</span>
                </div>

                <Form>
                  {productRows.map((row) => (
                    <Row className="align-items-center mb-3" key={row.id}>
                      <Col md={3}>
                        <label>Product Name</label>
                        <Select
                          isDisabled={loading}
                          value={productOptions.find((opt) => opt.value === row.product_name) || null}
                          onChange={(selected) =>
                            handleInputChange(row.id, "product_name", selected?.value || "")
                          }
                          options={productOptions}
                          placeholder={loading ? "Loading..." : "Select Product"}
                          isClearable
                        />
                      </Col>

                      <Col md={3}>
                        <label>PO Number</label>
                        <Select
                          isDisabled={loading}
                          value={poList.find((opt) => opt.value === row.po_number) || null}
                          onChange={(selected) =>
                            handleInputChange(row.id, "po_number", selected?.value || "")
                          }
                          options={poList}
                          placeholder={loading ? "Loading..." : "Select PO Number"}
                          isClearable
                        />
                      </Col>

                      {months.map((month) => (
                        <Col md={3} key={month.value}>
                          <label>{month.label} Production</label>
                          <Form.Control
                            type="number"
                            min="0"
                            placeholder={`${month.label} Qty`}
                            value={row.months[month.value] || ""}
                            onChange={(e) =>
                              handleInputChange(row.id, "months", e.target.value, month.value)
                            }
                          />
                        </Col>
                      ))}
                    </Row>
                  ))}

                  {/* Button */}
                  <Row className="mt-2">
                    <Col className="text-end">
                      <Button variant="dark" className="w-100 w-md-auto" onClick={handleSubmit}>
                        Update Plan
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </div>

            </Container>
          </Modal.Body>
        </div>
      </Modal>

      {/* Nested Modal */}
      <ModificationProductionProduct
        modificationId={modificationId}
        refreshParent={fetchModificationPlan}
        show={modificationProductionProduct}
        handleClose={() => setModificationProductionProduct(false)}
      />
    </>
  );
}
